import { CancelJobMatchMeetingComponent } from "./cancel-job-match-meeting.component";
export var CancelJobMatchMeetingModule = angular
    .module('cancelJobMatchMeeting', [])
    .component(CancelJobMatchMeetingComponent.selector, CancelJobMatchMeetingComponent.component)
    .name;
//# sourceMappingURL=cancel-job-match-meeting.module.js.map